export default {
  users: [],
  dashboard: []
}
